import {
  GET_PEOPLE,
  SET_PEOPLE_LOADING,
  SET_PEOPLE_END,
  SET_PEOPLE_TOTAL,
  CLEAR_PEOPLE,
  REMOVE_PERSON,
  SET_PEOPLE_PARAMS,
  CLEAR_PEOPLE_PARAMS,
  UPDATE_PEOPLE_ON_PEOPLE_LIST,
  REMOVE_PERSON_FROM_PEOPLE_LIST,
} from '../actions/People';

const initialPeopleParams = {
  orderBy: 'created_at',
  order: 'desc',
  page: 0,
  perPage: 40,
};

const initialState = {
  people: [],
  total: 0,
  loading: false,
  end: false,
  selectedPeople: [],
  params: { ...initialPeopleParams },
};

export const People = (state = initialState, action) => {
  switch (action.type) {
    case GET_PEOPLE:
      return {
        ...state,
        people: action.people === null ? [] :
          state.people.concat(action.people),
      };

    case SET_PEOPLE_LOADING:
      return ({ ...state, loading: action.loading });

    case SET_PEOPLE_END:
      return ({ ...state, end: action.end });

    case SET_PEOPLE_TOTAL:
      return ({ ...state, total: action.total });

    case SET_PEOPLE_PARAMS:
      return ({ ...state, params: { ...state.params, ...action.params } });

    case CLEAR_PEOPLE_PARAMS:
      return ({ ...state, params: { ...initialPeopleParams } });

    case CLEAR_PEOPLE:
      return ({ ...initialState });

    case REMOVE_PERSON:
      return ({
        ...state,
        people: state.people.filter(p => (p.uuid !== action.personUuid)),
      });

    case UPDATE_PEOPLE_ON_PEOPLE_LIST: {
      const newPeople = state.people.slice(0);
      action.people.forEach((person) => {
        const personIndex = newPeople.findIndex(f => (f.uuid === person.uuid));
        if (personIndex > -1) {
          newPeople.splice(personIndex, 1, person);
        }
      });
      return ({ ...state, people: newPeople });
    }

    case REMOVE_PERSON_FROM_PEOPLE_LIST: {
      let newPeople = state.people.slice(0);
      newPeople = newPeople.filter(nf => (nf.uuid !== action.personUuid));
      return ({ ...state, people: newPeople });
    }

    default:
      return state;
  }
};
